export const tableHeadConfig = [
  { id: 1, label: 'Item', isSortable: false },
  { id: 2, label: 'Description', isSortable: false },
  { id: 3, label: 'QTY', isSortable: false },
  { id: 4, label: 'Weight lbs', isSortable: false }
];
